// Which Meal Hat is this? And what does it know?
//
// Meal Hat keys a person's own hat by their email with punctuation swapped
// for '-' (mattgrosso-gmail-com) and records which hat they last used at
// <ownHat>/most-recent-database. The course follows that pointer, so a
// household sharing a hat shares its lessons too.
import { dbGet } from '../store/db.js';

// Meal Hat's own transform (src/store/index.js, `parsedEmail`), character for
// character: every punctuation mark INCLUDING the @ becomes a hyphen, and the
// case is left alone. mattgrosso@gmail.com → mattgrosso-gmail-com. This is a
// different transform from memberKey.mjs (the rules' one, which keeps the @
// and is only for bug-resolution notices); using that here produced
// tester@example-com and a 401 on every read.
export const ownHatKey = (email) =>
  String(email || '').replaceAll(/[-!$%@^&*()_+|~=`{}[\]:";'<>?,./]/g, '-') || null;

/** The hat this person is currently using in Meal Hat, or their own. */
export async function resolveHat (email) {
  const own = ownHatKey(email);
  if (!own) return null;
  try {
    const recent = await dbGet(`${own}/most-recent-database`);
    if (typeof recent === 'string' && recent.trim()) return recent.trim();
  } catch {
    // A brand-new Meal Hat user has no pointer yet; their own key is right.
  }
  return own;
}

/**
 * Everything a lesson needs to know about the kitchen, in one read each:
 * the grocery catalog (names + package sizes), the shopping list (what is
 * already going to be bought), the fridge key and then the fridge itself.
 * Any single failure leaves that part empty rather than failing the screen:
 * a lesson with no fridge knowledge is still a lesson.
 */
export async function loadKitchen (hat) {
  const [catalog, shoppingList, fridgeKey] = await Promise.all([
    dbGet(`${hat}/grocery-catalog`).catch(() => null),
    dbGet(`${hat}/shopping-list`).catch(() => null),
    dbGet(`${hat}/fridgeKey`).catch(() => null)
  ]);
  let timers = null;
  if (typeof fridgeKey === 'string' && fridgeKey.length >= 32) {
    timers = await dbGet(`fridge/${fridgeKey}/timers`).catch(() => null);
  }
  return {
    catalog: catalog || {},
    shoppingList: shoppingList || {},
    fridgeKey: typeof fridgeKey === 'string' ? fridgeKey : null,
    timers: timers || {}
  };
}
